import { ElementType } from 'react';
import { Instrument } from 'services/api/responses/responseTypes';
import Drums from './Drums';
import Bass from './Bass';
import Vocals from './Vocals';
import TonalPercussion from './TonalPercussion';
import Synth from './Synth';
import Strings from './Strings';
import Samples from './Samples';
import Percussion from './Percussion';
import Keys from './Keys';
import Guitar from './Guitar';
import FX from './FX';
import BrassWoodwind from './BrassWoodwind';
import Shuffle from './Shuffle';

export const instruments: Record<Instrument, ElementType> = {
  DRUMS: Drums,
  BASS: Bass,
  VOCALS: Vocals,
  'TONAL PERCUSSION': TonalPercussion,
  SYNTH: Synth,
  STRINGS: Strings,
  SAMPLES: Samples,
  PERCUSSION: Percussion,
  KEYS: Keys,
  GUITAR: Guitar,
  FX,
  'BRASS WOODWIND': BrassWoodwind,
};

export { Shuffle };

export default instruments;
